import { createElement } from '../../utils/utils';
export const Input = props => {
  const {
    type,
    checked,
    disabled
  } = props;
  const input = createElement({
    tagName: 'input',
    ...props
  });
  input.type = type;
  input.checked = checked || false;
  input.disabled = disabled;
  return input;
};
//# sourceMappingURL=input.js.map